import React, { useRef, useState, useContext } from 'react'
import { Link} from 'react-router-dom';
import {CTooltip} from '../../UI/CTooltip/CTooltip';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { TD } from '../../../styles/Table.styled';
import { useTheme } from 'styled-components';
import { connect } from 'react-redux';
import { UserStatus } from '../../../containers/UsersManagement/UsersManagement.styled';
import CancelIcon from '@mui/icons-material/Cancel';
import { showColumn, getAlignPosition } from '../../../shared/utility';
import Axios from '../../../axios-proas';
import * as actions from '../../../store/actions/index';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AbilityContext } from '../../../ability/AbilityContext';
import { createContextualCan } from '@casl/react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const Can = createContextualCan(AbilityContext.Consumer);

function TableBody(props) {
    const {
        data, 
        userType,
        selectedUsers,
        selectUserRow,
        unselectUserRow,
        disableUser,
        enableUser,
        columns,  
        setNewUserModal,
        initUserModal,
        DeleteUser,
        listOfRoles,
        userRoles,
        allBailleurs
    } = props;
    let textRef = useRef();
    const [confirmationModalShow, setConfirmationModalShow] = useState(false);
    const [userToDisable, setUserToDisable] = useState(null)
    const {t} = useTranslation();
    const theme = useTheme();
    const [confirmationDeleteModalShow, setConfirmationDeleteModalShow] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null)
    const [userToEnable, setUserToEnable] = useState(null)
    const ability = useContext(AbilityContext);

    const getSelectedRowValue = (userUid) => {
        let isSelected = selectedUsers.findIndex(uid => uid === userUid) >= 0;
        return isSelected
    }

    const selectRowHandler = (e) => {
        let uid = e.target.name;
        let val = e.target.checked;
        if(val)
            selectUserRow(uid)
        else
            unselectUserRow(uid)
    }
    

    const enableUserClickHandler = (id, email) => {
        setUserToEnable({ id, email })
        setConfirmationModalShow(true);
    }
    const deleteUserClickHandler = (id, email) => {
        setUserToDelete({id, email})
        setConfirmationDeleteModalShow(true);
    }

    const showUserModal = (userUid) => {
        initUserModal(userUid)
        //setConfirmationUserModalShow(true)
        setNewUserModal(false)
    }

    const getRolesName = (level) => {
        let temp = level?.map((item, index) => {
            return listOfRoles?.filter((temp) => temp?.roleId == item?.roleId)[0]?.libelle})
        return temp.join(', ');
    }
    const getPermissionsName = (claims) => {
        let temp = claims.filter((item) => item.claimType =="permissions")?.map((item, index) => {
            return item.claimValue
        })
        return temp.join(', ');
    }
    
    return (
        <>    
            {
                data?.map(row => ( 
                    <tr key={row.id} >
                        <TD style={{textAlign:'center'}}>
                            <input 
                                type="checkbox" 
                                name={row.id} 
                                onChange={(e) => selectRowHandler(e)} 
                                checked={getSelectedRowValue(row?.id)}  
                                className="form-check-input" 
                                style={{margin: 0}} 
                                id="exampleCheck1" 
                            />
                        </TD>  
                        {columns.filter(row => row.show == true).map(column => {
                            switch (column.field) {
                                case "userName":
                                    return <CTooltip title={row.userName} className="tableActions__icon">
                                                <TD style={{ display: !showColumn(columns, "userName") && 'none', textAlign: getAlignPosition(columns, 'userName') }}>
                                                    {/* {row.claims.filter(claim => claim.claimType == "given_name")[0]?.claimValue}*/}
                                                    {row.userName}
                                                 </TD>
                                    </CTooltip>
                                case "urn:younov:displayname":
                                    return <TD style={{ display: !showColumn(columns, "urn:younov:displayname") && 'none', textAlign: getAlignPosition(columns, 'urn:younov:displayname') }}>
                                       
                                        {row?.claims?.filter((item) => item?.claimType == "urn:younov:displayname")[0]?.claimValue.split('.')[0]}&nbsp;
                                        {row?.claims?.filter((item) => item?.claimType == "urn:younov:displayname")[0]?.claimValue.split('.')[1]}
                                    </TD>
                               
                                case "email":
                                    return <CTooltip title={row.email} className="tableActions__icon">
                                                <TD style={{ display: !showColumn(columns, "email") && 'none', textAlign: getAlignPosition(columns, 'email') }}>
                                                    {row.email}
                                                </TD>
                                            </CTooltip>
                                case "phoneNumber":
                                    return <TD style={{ display: !showColumn(columns, "phoneNumber") && 'none', textAlign: getAlignPosition(columns, 'phoneNumber') }}>
                                                {row.phoneNumber}
                                            </TD> 
                                case "lockoutEnd":
                                    return <TD style={{ display: !showColumn(columns, "lockoutEnd") && 'none' }} >
                                        <UserStatus
                                            style={{ backgroundColor: !row?.lockoutEnd ? theme.colors.success : theme.colors.danger }}
                                            color={!row?.lockoutEnd ? "#fff" : "#fff"}
                                        >
                                            {/* {new Date(row?.lockoutEnd) >= new Date() ? "Oui" : "Non"}*/}
                                            {!row?.lockoutEnd ? "Oui" : "Non"}
                                        </UserStatus>
                                    </TD>
                                case "role":
                                    return <CTooltip title={getRolesName(row?.roles)} className="tableActions__icon">
                                                <TD style={{ display: !showColumn(columns, "role") && 'none', textAlign: getAlignPosition(columns, 'role') }}>
                                                    {getRolesName(row?.roles)}
                                                </TD>
                                            </CTooltip>
                                case "permission":
                                    return <CTooltip title={getPermissionsName(row?.claims)} className="tableActions__icon">
                                        <TD style={{ display: !showColumn(columns, "permission") && 'none', textAlign: getAlignPosition(columns, 'role') }}>
                                            {getPermissionsName(row?.claims)}
                                        </TD>
                                    </CTooltip>
                                case "BailleurName":
                                    return <TD style={{ display: !showColumn(columns, "BailleurName") && 'none', textAlign: getAlignPosition(columns, 'BailleurName') }}>
                                                <CTooltip title={ allBailleurs?.filter((item) => item.id == row?.claims?.filter((item) => item?.claimType == "bailleur_id")[0]?.claimValue)[0]?.raisonSociale} className="tableActions__icon">
                                                    <span ref={textRef}>

                                                        {allBailleurs?.filter((item) => item.id == row?.claims?.filter((item) => item?.claimType == "bailleur_id")[0]?.claimValue)[0]?.raisonSociale}
                                                    </span>
                                                </CTooltip>
                                            </TD>

                            }
                        })}

                        <TD className="userManag_td">
                        
                            <CTooltip title={row.favoriteColor == "0" ? "Voir" : "Modifier"} className="tableActions__icon">
                                {false ?
                                    <VisibilityIcon className="editIcon" fontSize="small" style={{ color: "#2174B9", cursor: "pointer" }} onClick={e => showUserModal(row?.id)} />
                                    : <EditIcon className="editIcon" fontSize="small" style={{ color: "#2174B9", cursor: "pointer" }} onClick={e => showUserModal(row?.id)} />
                                }
                            </CTooltip>

                            
                            {ability.can('delete', 'User') && !row?.lockoutEnd &&
                                <CTooltip title={"Désactiver cet utilisateur"} className="tableActions__icon">
                                    <CancelIcon
                                        style={{ marginLeft: '0.25rem', color: "#ea0606", cursor: 'pointer' }}
                                        fontSize="small"
                                        onClick={() => deleteUserClickHandler(row?.id, row?.email)}
                                    />
                                </CTooltip>
                            }
                            {ability.can('delete', 'User') && row?.lockoutEnd &&
                                <CTooltip title={ "Activer cet utilisateur"} className="tableActions__icon">
                                    <CheckCircleIcon
                                       style={{ marginLeft: '0.25rem', color: "#82d616", cursor: 'pointer' }}
                                        fontSize="small"
                                        onClick={() => enableUserClickHandler(row?.id, row?.email)}
                                    />
                                </CTooltip>
                            }
                            
                        </TD>
                    </tr>
                ))
            }
            
            <ConfirmationModal 
                show={confirmationModalShow}
                modalClosed={() => setConfirmationModalShow(false)}
                confirm={() => enableUser(userToEnable?.id)}
                cancel={() => setConfirmationModalShow(false)}
                title={"Confirmation d'activation"}
                message={`Êtes-vous sûr de vouloir activer cet utilisateur (${userToEnable?.email})?`}
            />
            <ConfirmationModal 
                show={confirmationDeleteModalShow}
                modalClosed={() => setConfirmationDeleteModalShow(false)}
                confirm={() => disableUser(userToDelete?.id)} // avant DeleteUser
                cancel={() => setConfirmationDeleteModalShow(false)}
                title={"Confirmation de désactivation"}
                message={`Êtes-vous sûr de vouloir désactiver cet utilisateur (${userToDelete?.email})?`}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    login: state.auth.login,
    userRoles: state.auth.userRoles,
    connectedUserId: state.auth.connectedUserId
})
const mapDispatchToProps = dispatch => ({
   
})
export default connect(mapStateToProps, mapDispatchToProps)(TableBody)

